import { faApple, faSpotify } from "@fortawesome/free-brands-svg-icons";
import { faX, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import FEATURE_IMG from "../assets/images/feature.png";
import useGlobalService from "../features/Global/useGlobalService";
import { useGlobalSelector } from "../features/useSelector";
import { motion } from "framer-motion";
import { fade, fadeInOut } from "../util";
import { useEffect, useState } from "react";
import MyAsset from "../asset_strings";
import $ from "jquery";

import SHIRT from "../assets/images/Tee Shirt.png";
import HOODIE from "../assets/images/Zip Up Hoodie.png";

export default function BuyNowPopup() {
    const { presavePopupOpen: open } = useGlobalSelector();
    const [initialOpen, setInitialOpen] = useState(false);
    const { setPresavePopupOpen } = useGlobalService();

    useEffect(() => {
        setTimeout(() => {
            setInitialOpen(open);
        }, 700);
    }, [open]);

    return (
        <div
            className={`font-secondary flex left-0 fixed w-full h-screen px-[--default-space] ${initialOpen ? "top-0 opacity-100" : "-top-[120%] opacity-0"
                }`}
            style={{ zIndex: 123123123123 }}
        >
            <motion.div
                initial="visible"
                animate={open ? "visible" : "hidden"}
                variants={fade}
                className={`bg-black border-[.2vw] border-brand relative m-auto shadow-lg gap-[--space-between-items]  p-[2vw] flex flex-col justify-center items-center w-full md:w-1/2 md:h-auto`}
            >
                <div className="absolute top-0 md:top-2 right-1 md:right-3 text-xl md:text-3xl cursor-pointer font-wingdings2" onClick={() => setPresavePopupOpen(false)}>Ò</div>
                <div>
                    <h1 className="section-heading text-center text-brand px-8 md:px-0">
                        SAINt JHN x WhyHunger
                    </h1>
                </div>
                <div className="flex justify-center items-center gap-2 md:gap-4">
                    <div className="w-1/2 flex flex-col jusityf-center items-center gap-2">
                        <img className="w-full cursor-pointer" src={SHIRT} onClick={() => window.open("https://hungerthon.org/products/saint-jhn-x-whyhunger-oversized-t-shirt", "_blank")} />
                        <button
                            className="btn-primary text-[100%] md:text-[85%] z-10 w-full whitespace-nowrap"
                            onClick={() => {
                                // setPresavePopupOpen(false);
                                window.open("https://hungerthon.org/products/saint-jhn-x-whyhunger-oversized-t-shirt", "_blank");

                                // scroll at the middle
                                const bgWidth = document.querySelector("#video")?.clientWidth;
                                if (!bgWidth) return;
                                document.body.scrollLeft = bgWidth / 2 - 200;
                            }}
                        >
                            {/* Pre-Save */}
                            Buy Now
                        </button>
                    </div>
                    <div className="w-1/2 flex flex-col jusityf-center items-center gap-2">
                        <img className="w-full cursor-pointer" src={HOODIE} onClick={() => window.open("https://hungerthon.org/products/saint-jhn-x-whyhunger-black-zip-up-hoodie", "_blank")} />
                        <button
                            className="btn-primary text-[100%] md:text-[85%] z-10 w-full whitespace-nowrap"
                            onClick={() => {
                                // setPresavePopupOpen(false);
                                window.open("https://hungerthon.org/products/saint-jhn-x-whyhunger-black-zip-up-hoodie", "_blank");

                                // scroll at the middle
                                const bgWidth = document.querySelector("#video")?.clientWidth;
                                if (!bgWidth) return;
                                document.body.scrollLeft = bgWidth / 2 - 200;
                            }}
                        >
                            {/* Pre-Save */}
                            Buy Now
                        </button>
                    </div>
                </div>
                <div>
                    <h1 className="text-center text-brand px-8 md:px-0 text-2xl md:text-3xl">
                        100% of proceeds support the fight to end hunger
                    </h1>
                </div>
            </motion.div>
        </div>
    );
}
